module.exports = __webpack_public_path__ + "img/jne.da3e202f.png";